import { connect } from 'react-redux'
import { PuzzleInfoDialog } from '../../../components'
import * as actions from '../../../actions'

const mapStateToProps = (state, ownProps) => {
  const { open, puzzleInfo } = state.puzzleInfoDialog
  const { language } = state.user
  return ({
    open,
    puzzleInfo,
    ...puzzleInfo,
    language,
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
    textFieldProps: {
      handleChangeText: (name) => (event) => {
        dispatch(actions.puzzleInfoDialog.changedText(name, event.target.value))
      }
    },
    dialogProps: {
      handleEnter: () => {
        ownProps.onEnter()
      },
      handleClose: () => {
        dispatch(actions.puzzleInfoDialog.close())
      },
      handleOK: (puzzleInfo) => () => {
        ownProps.onOK(puzzleInfo)
        dispatch(actions.puzzleInfoDialog.close())
      }
    }
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PuzzleInfoDialog)



// WEBPACK FOOTER //
// ./src/containers/Common/RenjuBoardCard/PuzzleInfoDialog.js